<template>
	<div class="loginPage">
<!--		<div>-->
<!--			<van-circle v-model="currentRate" :rate="30" :speed="100" :text="text"/>-->
<!--		</div>-->
		<div>
			<img class="logoImg" src="../../public/assets/logo.png"/>
		</div>
		<van-form>
			<van-field
				v-model="params.username"
				name="用户名"
				label="用户名"
				placeholder="用户名"
			>
			</van-field>
			<van-field
				v-model="params.password"
				type="password"
				name="密码"
				label="密码"
				placeholder="密码"
			/>
			<div style="margin: 16px;">
				<van-button round block type="info" native-type="submit" @click="OnLogin">提交</van-button>
			</div>
		</van-form>
		<div class="link_retrieve" v-on:click="OnRetrieve"> 还没有账号，点击注册</div>
	</div>
</template>

<script>
import login from "../api/login";
import {mapGetters, mapMutations} from "vuex";
import wordBook from "../api/wordBook";

export default {
	data() {
		return {
		    params : {
                username: '',
                password: '',
            },

			currentRate: 10,
			text: '',
			data: [
				{name: 'da'},
				{name: 'da2'},
				{name: 'da3'},
			]
		}
	},
	methods: {
        ...mapMutations({
            setUser : 'setUser',
        }),
		onSubmit() {
			// console.log('点击')
			// this.$router.push({name : 'Retrieve'})
		},
		OnRetrieve (){
			this.$router.push({name : 'Retrieve'})
		},
		OnLogin(){
            login.login(this.params).then(res => {
                if (res.code === 200){
                    localStorage.setItem('token',res.data.token)
                    this.setUser(res.data)
                    //查看是否有加入单词本记录
                    wordBook.currentBook().then(res => {
                        if (res.data){
                            // 已选择书本的用户跳转学习计划页
                            this.$router.push({name : 'BookPlan', query:{id : res.data.id}})
                        }else {
                            // 新用户跳转书本选择页
                            this.$router.push({name : 'WordBook'})
                        }
                    })
                }else {
                    this.$toast(res.message)
                }
            })
		}
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
	.loginPage{
		overflow: hidden;
		.logoImg{
			margin: 16px;
			border-radius: 20%;
			max-height: 160px;
			max-width: 160px;
		}
		.link_retrieve{

			margin-top: 50px;
			text-decoration: underline;
			color:#1879E5;
			display: block;
		}

	}
</style>



// WEBPACK FOOTER //
// src/views/Login.vue